<template>
    <section>
      <div class="transaction-card">
        <div class="container-transaction-card">
          <div class="transaction-date">
            <span>{{dateString}}</span>
          </div>
          <div class="transaction-summary">
            <span>{{transaction.summary}}</span>
          </div>  
        </div>
      </div>
    </section>
</template>

<script>
import { db } from '../db'
import firebase from "firebase";

import { DateTime } from 'luxon';

export default {
  data() {
    return { 
      
    }
  },
  props: {
     transaction: {
      type: Object,
      required: true,
      default: null
     }
  },
  computed: {
    dateString() {
      return DateTime.fromMillis(this.transaction.date).toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' })
    }
  }
}

</script>

<style>
.transaction-card {
  /* Add shadows to create the "card" effect */
/*  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
*/  transition: 0.3s;
}
.container-transaction-card {
  padding: 4px 4px;
  display: block;
  border-top: 1px solid #f3f3f3;
}
.container-transaction-card .transaction-summary {
  display: table-cell;
  width: calc(100% - 40px);
}
.container-transaction-card .transaction-date {
  display: inline-block;
  width: 100%;
  color: #bbb;
  font-style: italic;
  font-size: 12px;
  box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/components/PastTransaction.vue